import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    const timeout = setTimeout(() => {
      const scrollableDiv = document.querySelector(
        ".flex-1.custom-scrollbar1"
      ) as HTMLElement | null;

      if (scrollableDiv) {
        scrollableDiv.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 150);

    return () => clearTimeout(timeout);
  }, [pathname]);

  return null;
}
